/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Updates_AvailableInputs */



/**
* | output |
* | --- |
* | "No Updates Available" |
*
* @param {No_Updates_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_updates_available = /** @type {((inputs?: No_Updates_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Updates_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune mise à jour disponible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Aktualisierungen verfügbar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun aggiornamento disponibile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновления отсутствуют")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay actualizaciones disponibles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用可能なアップデートはありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई अपडेट उपलब्ध नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma atualização disponível")
	return /** @type {LocalizedString} */ ("No Updates Available")
});